export const time = process.env.VUE_APP_TIMEOUT